













































































































































































































import Vue from "vue";
import { components } from "aws-amplify-vue";
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
import Component from "vue-class-component";
// import HelloWorld from "./components/HelloWorld.vue";

@Component
export default class App extends Vue {
  drawer = null;
  platforms = ["facebook", "google", "snapchat", "tiktok"];
  components = {
    components
  };
  groups: string[] = [];
  signedIn = false;
  created() {
    this.$vuetify.theme.dark = true;
  }
  async beforeCreate() {
    try {
      const u = await Auth.currentAuthenticatedUser();

      if (u) {
        this.groups =
          u.signInUserSession.accessToken.payload["cognito:groups"] ?? [];
      }
      // console.log(process.env.VUE_APP_SUDOKU_API_BASEURL);
      // console.log(process.env.VUE_APP_FACEBOOK_API_BASEURL);
      // console.log(process.env.VUE_APP_MOTION_API_BASEURL);
      this.signedIn = true;
    } catch (err) {
      // console.log(err);
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", (info: string) => {
      if (info === "signedIn") {
        this.signedIn = true;
      } else {
        this.signedIn = false;
      }
    });
  }
}
